import React from 'react';
import { observer } from 'mobx-react-lite';

const OpenDisclosureModal = observer(function OpenDisclosureModal({ store }) {
  return (
    <a onClick={store.openDisclosureModal} className={store.className}>
      {store.buttonText}
    </a>
  );
});

export default OpenDisclosureModal;
